export default __webpack_public_path__ + "static/image6-f603eac2eb5124f429cd1387a5ec4662.gif";